// Conta na Iugu (IUGU_V2): mesmo login e PIN da conta CDC, mas sem Pix por
// chave e sem pagamento de contas por enquanto.
export function isIuguAccount(account?: { provider?: string } | null): boolean {
  return account?.provider === "IUGU_V2";
}

export const ACCOUNT_LABELS: Record<string, string> = {
  CDC: "Conta CDC",
  IUGU: "Conta Iugu",
};
